import React, { useEffect } from "react";
import { Button, Form, Modal, Row, Col } from "@themesberg/react-bootstrap";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSave } from "@fortawesome/free-solid-svg-icons";
import RenderCustomIputs from "../RenderCustomInputs";
import StockService from "../../../../services/StockService";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
const AddSupplierModal = (props) => {
  const { show, handleClose, setShow, refreshData } = props;
  const [update, setUpdate] = useState(0);
  const [company_name, setCompany_name] = useState("");
  const [logo, setLogo] = useState("");
  const [phones, setPhones] = useState([""]);
  const [addresses_mails, setAddresses_mails] = useState([""]);
  const [address, setAddress] = useState("");
  const [leader_company, setLeader_company] = useState("");

  useEffect(() => {
    // setPhones(inputs);
  }, [update]);

  const addSupplier = async (e) => {
    e.preventDefault();
    console.log(company_name, phones);
    try {
      const res = await StockService.addSupplier({
        company_name,
        phones,
        addresses_mails,
        address,
        logo,
        leader_company,
      });
      if (res.status === 200) {
        NotificationManager.success(res.data.message, "Stock");
        handleClose();
        refreshData();
      }
    } catch (err) {
      NotificationManager.error(err?.response?.data?.message, "Stock");
    }
  };

  return (
    <>
      <Modal
        as={Modal.Dialog}
        centered
        show={show}
        onHide={handleClose}
        size={"lg"}
      >
        <Modal.Header>
          <Modal.Title className="h6">
            <FontAwesomeIcon icon={faPlus} /> Ajouter nouveau fournisseur
          </Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <div className={""}>
            <Form onSubmit={addSupplier}>
              <Row>
                <Col>
                  {" "}
                  <Form.Group className="mb-2">
                    <Form.Label>Nom de la sociéte </Form.Label>
                    <Form.Control
                      value={company_name}
                      onChange={(e) => setCompany_name(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-2">
                    <Form.Label>Gérant de la sociéte </Form.Label>
                    <Form.Control
                      value={leader_company}
                      onChange={(e) => setLeader_company(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-2">
                <Form.Label>Adresse </Form.Label>
                <Form.Control
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Row>
                <Col md={5}>
                  {" "}
                  <RenderCustomIputs
                    global_inputs={phones}
                    input_label={`Numéro de téléphone`}
                    new_label={`Ajouter un autre Numéro de téléphone`}
                    setGlobalInputs={(value) => setPhones(value)}
                  />
                </Col>
                <Col md={7}>
                  {" "}
                  <RenderCustomIputs
                    global_inputs={addresses_mails}
                    input_label={`Adresse émail`}
                    new_label={`Ajouter une autre Adresse émail`}
                    setGlobalInputs={(value) => setAddresses_mails(value)}
                  />
                </Col>
              </Row>

              <Form.Group className="mb-2">
                <Form.Label>Logo</Form.Label>
                <Form.Control type="file"></Form.Control>
              </Form.Group>

              <Form.Group className="d-flex justify-content-end">
                <Button type="submit" variant={"main"}>
                  <FontAwesomeIcon icon={faSave} /> Sauvegarder{" "}
                </Button>
              </Form.Group>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddSupplierModal;
